import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {AuthPanelPage} from "../AuthPanelPage.jsx";
import {Messages} from "../../../../Messages";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {BasePanelPageStyle} from "../BasePanelPage";


class SubscribeAuthPageStyle extends BasePanelPageStyle {
    @styleRule
    message = this.themeProps.PANEL_MESSAGE_STYLE;
}

@registerStyle(SubscribeAuthPageStyle)
export class SubscribeAuthPage extends AuthPanelPage {
    render() {
        return [
            Messages.subscribeInlineAuth1.toString().trim() ?
                <MessageElement message={Messages.subscribeInlineAuth1(iFrameMerchantService.getMerchant().name)}
                                className={this.styleSheet.message}/> : null,
            super.render()
        ];
    }
}
